<template>
  <list :state="0" ref="list">
    <template slot-scope="{ data }">
      <el-link v-action="'/api/ProjectManage/Enroll/Audit'" type="primary" @click="onAudit(data)">审核</el-link>
      <template v-if="data.Proposer.Id == user.Id">
        <el-link v-action="'/api/ProjectManage/Enroll/Submit'" type="primary" @click="$router.push({ path: 'form', query: { id: data.Id } })">修改</el-link>
        <el-link v-action="'/api/ProjectManage/Enroll/Detele'" type="danger" @click="onDelete(data.Id)">删除</el-link>
      </template>
    </template>
  </list>
</template>


<script>
export default {
  components: { list: () => import("./list.vue") },
  data () {
    return {
      user: JSON.parse(localStorage.getItem('user'))
    }
  },
  methods: {
    //审批
    onAudit (data) {
      this.$prompt(null, '报备审核', {
        confirmButtonText: '通过',
        cancelButtonText: '拒绝',
        inputType: 'textarea',
        distinguishCancelAndClose: true,
        center: true,
        callback: (action, instance) => {
          if (action == "close") { return }
          this.$apis.project.enroll.audit({
            Id: data.Id,
            State: action == 'confirm',
            AuditOpinion: instance.inputValue
          }).then((res) => {
            this.$refs.list.loadData()
            this.$message({
              message: res || "执行成功！",
              type: "success",
            })
          })
        }
      })
    },
    //删除
    onDelete (id) {
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        center: true
      }).then(() => {
        this.$apis.project.enroll.delete({ id: id }).then(() => {
          this.$refs.list.loadData()
          this.$message({ message: "数据提交成功！", type: "success" })
        }).catch((e) => {
          this.$message.error(e)
        })
      })
    }
  }

}
</script>